"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardAuthenticationBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_card_authentication_constants_1 = require("./bc-card-authentication-constants");
var bc_card_authentication_constants_2 = require("./bc-card-authentication-constants");
var bc_card_authentication_constants_3 = require("./bc-card-authentication-constants");
var bc_card_authentication_constants_4 = require("./bc-card-authentication-constants");
var bc_card_authentication_constants_5 = require("./bc-card-authentication-constants");
var bc_card_authentication_constants_6 = require("./bc-card-authentication-constants");
var BcCardAuthenticationBehavior = (function (_super) {
    __extends(BcCardAuthenticationBehavior, _super);
    function BcCardAuthenticationBehavior() {
        var _this = _super.call(this) || this;
        _this.button = null;
        _this.formValidate = _this.validateForm.bind(_this);
        return _this;
    }
    BcCardAuthenticationBehavior.setUpAll = function () {
        var cardAuthGroup = Array.from(document.querySelectorAll(".".concat(bc_card_authentication_constants_1.BC_CARD_AUTHENTICATION)));
        var elements = [];
        for (var _i = 0, cardAuthGroup_1 = cardAuthGroup; _i < cardAuthGroup_1.length; _i++) {
            var element = cardAuthGroup_1[_i];
            var bcCardAuthentication = new BcCardAuthenticationBehavior();
            bcCardAuthentication.setElement(element);
            bcCardAuthentication.setUp();
            elements.push(bcCardAuthentication);
        }
        return elements;
    };
    BcCardAuthenticationBehavior.prototype._setUp = function () {
        var _this = this;
        _super.prototype._setUp.call(this);
        this.button = this.mySelf.querySelector(".".concat(bc_card_authentication_constants_4.BC_CARD_BUTTON_PRIMARY));
        this.button.addEventListener('click', function (e) {
            e.preventDefault();
            _this.validateForm();
        });
        this.inputLimit();
    };
    BcCardAuthenticationBehavior.prototype.validateForm = function () {
        var formRequired = this.mySelf.querySelectorAll('form input[data-required="true"]');
        formRequired.forEach(function (input) {
            if (!input.value) {
                input.classList.add(bc_card_authentication_constants_6.BC_CARD_INPUT_ERROR);
            }
            else {
                input.classList.remove(bc_card_authentication_constants_6.BC_CARD_INPUT_ERROR);
            }
        });
        var valid = !Array.from(formRequired).find(function (input) { return !input.value; });
        var form = this.mySelf.querySelectorAll(bc_card_authentication_constants_5.BC_CARD_INPUT);
        var values = Array.from(form).map(function (input) { return input.value; });
        if (this.outputFunction) {
            this.outputFunction(values, valid);
        }
    };
    BcCardAuthenticationBehavior.prototype.inputLimit = function () {
        var container = this.mySelf.querySelector(".".concat(bc_card_authentication_constants_2.BC_CARD_AUTH_CONTAINER));
        var maxInputs = bc_card_authentication_constants_3.BC_CARD_AUTH_MAX_INPUTS;
        var inputs = container.querySelectorAll(bc_card_authentication_constants_5.BC_CARD_INPUT);
        if (inputs.length >= maxInputs) {
            var children = container.children;
            for (var _i = 0, _a = children; _i < _a.length; _i++) {
                var value = _a[_i];
                if (maxInputs <= children.length) {
                    var indexToRemove = bc_card_authentication_constants_3.BC_CARD_AUTH_MAX_INPUTS;
                    container.removeChild(children[indexToRemove]);
                }
            }
        }
    };
    return BcCardAuthenticationBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCardAuthenticationBehavior = BcCardAuthenticationBehavior;
